import { render, staticRenderFns } from "./MyArticles.vue?vue&type=template&id=ab2ac6e0&"
import script from "./MyArticles.vue?vue&type=script&lang=js&"
export * from "./MyArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports